import React, { useState } from 'react'
import { MICREDITO } from '../../global/const'
import axios from 'axios'
import SemiCircleProgressBar from "react-progressbar-semicircle";
import arrow from '../../assets/icons/arrow2.svg';
const MiCredito = () => {
    const [credito, setCredito] = useState([]);
    const [movil, setMovil] = useState(false);
    React.useEffect(() => {
        window.scrollTo(0, 0);
        getMiCredito();

    }, [])

    const getMiCredito = (response) => {
        axios.get(MICREDITO + `?nit=${credito.nit}&codigo=${credito.codigo}&agencia=${credito.agencia}`)
            .then((res) => {
                setCredito(res.data);
            }).catch((error) => {
                console.log(error);
            })
    }
    return (
        <div className="bodyMiCredito">
            <h1> Mi Crédito</h1>
            <h4 className="title"> Revisa el estado de cuenta del cupo de crédito que tienes con nosotros, podrás pagar y ver el detalle del cupo usado.   </h4>
            <hr />
            <div className="barra">
                <SemiCircleProgressBar percentage={(credito.cupoUsado * 100) / credito.cupoTotal} showPercentValue strokeWidth={30} background={'#DBE5FD'} stroke={'#EFB71B'} diameter={500} />
            </div>
            <div className="barraMovil">
                <SemiCircleProgressBar percentage={(credito.cupoUsado * 100) / credito.cupoTotal} showPercentValue strokeWidth={20} background={'#DBE5FD'} stroke={'#EFB71B'} diameter={300} />
            </div>
            <div className="texto">

                <div className="tooltip-container">
                    <span className="tooltip-trigger">
                        <span > Cupo Total</span>
                    </span>
                    <div className="tooltip-one">
                        <div className="txt" align="center">
                            <p>Cupo Disponible + Cupo Usado </p>

                        </div>
                    </div>
                </div>

                <div className="cupoTotal">
                    <h4 className="ahora">  {" $" +
                        new Intl.NumberFormat("de-DE", {
                            numberingSystem: "latn",
                            style: "decimal",
                            currency: "COP",
                        }).format(credito.cupoTotal)
                    }</h4>
                </div>
                <button className="btnPagar"> Pagar Crédito  </button>
                <h2>   Plazo Crédito {credito.plazoCredito} días</h2>

                <div className="recuadros">

                    <div className="contenidoCupoDisponible">
                        <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}><span className="disponible"> Cupo Disponible</span>
                            <h4 className="hContenido">Corresponde al Limite de Tu Crédito</h4>
                        </div>

                        <div className="cupoTotalContenido cupoTotalDisponible">
                            <h4 className="ahora">  {" $" +
                                new Intl.NumberFormat("de-DE", {
                                    numberingSystem: "latn",
                                    style: "decimal",
                                    currency: "COP",
                                }).format(credito.cupoDisponible)
                            }  </h4>


                        </div>

                    </div>


                    <div className="contenido">

                        <span className="cupo">Cupo Usado</span>
                        <h4 className="hContenido">Corresponde al Limite de Tu Crédito</h4>
                        <div className="cupoTotalContenido" style={{ backgroundColor: '#FAFAFA' }}>
                            <h4 className="ahora">  {" $" +
                                new Intl.NumberFormat("de-DE", {
                                    numberingSystem: "latn",
                                    style: "decimal",
                                    currency: "COP",
                                }).format(credito.cupoUsado)
                            } </h4>

                            <div className="cupoTotalContenido-icon"><i className="fas fa-caret-down"></i></div>
                        </div>

                    </div>

                    <div className="contenido">

                        <span> Crédito Vencido</span>
                        <h4 className="hContenido">Corresponde al Limite de Tu Crédito</h4>
                        <div className="cupoTotalContenido " style={{ backgroundColor: '#FAFAFA' }}>
                            <h4 className="ahora">  {" $" +
                                new Intl.NumberFormat("de-DE", {
                                    numberingSystem: "latn",
                                    style: "decimal",
                                    currency: "COP",
                                }).format(credito.creditoVencido)
                            } </h4>
                            <div className="cupoTotalContenido-icon"><i className="fas fa-caret-down"></i></div>
                        </div>

                    </div>


                </div>

            </div>
            <hr />
        </div>

    )
}

export default MiCredito;